import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container, Box, CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';
import logo from '../assets/Tekpro-logo.png';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1, 3),
  background: '#ffffff',
  borderBottom: '1px solid #e0e0e0',
}));

const Logo = styled('img')({
  height: '55px',
  marginRight: '24px',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
});

const Layout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <AppBar position="static" elevation={0} sx={{ backgroundColor: '#ffffff' }}>
        <StyledToolbar>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Logo src={logo} alt="Tekpro Logo" />
            <Typography 
              variant="h5" 
              sx={{ 
                color: '#1976d2',
                fontWeight: 600,
                letterSpacing: '0.5px',
                fontFamily: '"Poppins", sans-serif',
              }}
            >
              SSL Certificate Monitor
            </Typography>
          </Box>
        </StyledToolbar>
      </AppBar>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, flex: 1 }}>
        <Outlet />
      </Container>
    </Box>
  );
};

export default Layout; 